import { useTranslation } from "react-i18next";
import CustomModal from "components/lib/customModal";
import { Typography } from "components/typography";
import { isErrorWithMessage } from "api/helpers";
import { styled } from "styled-components";
import { Row } from "components/lib/customModal/customModal.styles";
import { Button, useSnackbar } from "@mindlercare/ui-web";
import { useDeleteAttachment } from "./hooks";

type Props = {
  onClose: () => void;
  onSuccess: () => void;
  open: boolean;
  uploadedAttachmentKeys: string[] | null;
};

export const UnsavedChangesModal = ({
  onClose,
  open,
  onSuccess,
  uploadedAttachmentKeys,
}: Props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const handleCancel = () => {
    onClose();
  };

  const { mutateAsync } = useDeleteAttachment();

  const handleDelete = async () => {
    try {
      await Promise.all(
        (uploadedAttachmentKeys || []).map((key) => {
          if (!key) return Promise.resolve();
          return mutateAsync(key);
        }),
      );

      onSuccess();
    } catch (error) {
      if (isErrorWithMessage(error, "Not Authorized")) {
        enqueueSnackbar({
          text: t("NOT_PATIENT_DELETE_MESSAGE_ERROR"),
          isError: true,
        });
      } else {
        enqueueSnackbar({
          text: t("SOMETHING_WENT_WRONG"),
          isError: true,
        });
      }
    }

    onClose();
  };

  return (
    <CustomModal.Wrapper onClose={onClose} open={open} size="small">
      <div>
        <Typography insensitive variant="h3" style={{ textAlign: "center" }}>
          {t("DELETE_CLEANUP_MESSAGE")}
        </Typography>
        <RowCenter>
          <Button variant="secondary" onClick={handleCancel}>
            {t("CANCEL")}
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            {t("CONFIRM")}
          </Button>
        </RowCenter>
      </div>
    </CustomModal.Wrapper>
  );
};

const RowCenter = styled(Row)`
  justify-content: center;
  gap: 10px;
`;
